import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Col, Nav } from "react-bootstrap";
import "./styles.css";
import { MenuOption } from "./types";

interface Props {
  options: MenuOption[];
}

const slugify = (option: MenuOption) => {
  if (option === MenuOption.Billing) return "billing";
  return option.toLowerCase().replace(/\s/g, "");
};

export default function Menu({ options }: Props): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const { user_id } = useParams();

  const pathParts = location.pathname.toLowerCase().split("/");
  const activeKey = pathParts[pathParts.indexOf("edit") + 1] || "";

  const handleSelect = (eventKey: string | null) => {
    if (!eventKey) return;
    navigate(`/users/${user_id}/edit/${eventKey}`);
  };

  return (
    <>
      <h3 className="menu-title">Account Preferences</h3>
      <hr style={{ marginTop: "3px", marginBottom: "3px", width: "90%" }} />
      <Nav
        variant="pills"
        className="flex-column"
        activeKey={activeKey}
        onSelect={handleSelect}
      >
        {options.map((option, index) => (
          <Nav.Item key={index} className="nav-item">
            <Nav.Link eventKey={slugify(option)} className="nav-link">
              {option}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </>
  );
}
